import { BrandInfoProps } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/BrandInfo/brandInfoProps";
import { IOnProductClickBase } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/productTileActions/IOnProductClickBase";
import { IBadgeList } from "@faire/web-api--source/indigofair/badges/IBadgeList";

export interface SearchProductTileBrandLinkProps {
  trackingParams: ProductClickForSearchPageParameters;
  brandToken: string;
  productSearchString: string;
  brandUrl?: string;
}
export interface ProductClickForSearchPageParameters
  extends IOnProductClickBase {
  badgeList?: IBadgeList;
  isPromoted?: boolean;
}

export const productTileBrandLinkPropsAdapter = (
  data: BrandInfoProps
): SearchProductTileBrandLinkProps => {
  const trackingParams: ProductClickForSearchPageParameters = {
    //Product token
    token: data.token,
    isPromoted: data.isPromoted,
    impressionId: data.impressionId,
    promotedBy: data.promotedBy,
    badgeList: data.badgeList,
    bestImage: data.bestImage,
    images: data.images,
  };
  return {
    trackingParams,
    brandToken: data.brandToken ?? "",
    productSearchString: data.productSearchString,
    brandUrl: data.brandUrl,
  };
};
